/*
 * File: FlyToTargetContext.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 1, 2022 at 8:02 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 4, 2025 at 8:46 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div``;

export const FlightRisk = styled.div`
	width: ${({ $size }) => $size.width}px;
	height: ${({ $size }) => $size.height}px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	z-index: 9999;
	visibility: hidden;
	transform: translate3d(0, 0, 0);

	&.move {
		visibility: visible;
		transform: ${({ $transformX, $transformY }) => `translate3d(${$transformX}px, ${$transformY}px, 0)`};
		transition: transform ${({ $animationDuration }) => $animationDuration}s ease-out;
		animation : fade ${({ $animationDuration }) => $animationDuration + 0.1}s;
	}
	@keyframes fade {
		0% {
			opacity: 1;
		}
		60% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}
`;
